import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { AvailableModels } from 'bloggers-backend/lib/aiagents/settings';
import { AppContext } from '../../../AppContext';

export function useAvailableModels() {
  const {client} = React.useContext(AppContext);

  const {data} = useQuery<AvailableModels | undefined>(['aiagents', 'getModels'], async () => {
    const result = await client<{event: string, data: object}, {success: boolean, value?: AvailableModels}>(
      {event: 'aiagents.getModels', data: {}},
    );

    return result.success ? result.value : undefined;
  });

  return data;
}
